import { AvatarProps } from "@mui/material";
import { forwardRef } from "react";

import MDAvatarRoot from "./MDAvatarRoot";

type MDAvatarProps = AvatarProps & {
  bgColor?:
    | "transparent"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark";
  size: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
  shadow?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "inset";
};

const MDAvatar = forwardRef<HTMLDivElement, MDAvatarProps>(
  ({ bgColor = "transparent", size = "md", shadow, ...rest }: MDAvatarProps, ref) => (
    <MDAvatarRoot ref={ref} ownerState={{ shadow, bgColor, size }} {...rest} />
  )
);

MDAvatar.displayName = "MDAvatar";
export default MDAvatar;
